import { PlotsListPage } from '@/components/plots/plots-list-page'

export function OperationsPlots() {
  return (
    <PlotsListPage
      plotsBasePath="/operations/plots"
      membersBasePath="/operations/members"
      canManage
    />
  )
}
